var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomStarterIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#2B66F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7499 13.8335C15.1391 13.8335 13.8333 15.1393 13.8333 16.7502V34.2502C13.8333 35.861 15.1391 37.1668 16.7499 37.1668H34.2499C35.8607 37.1668 37.1666 35.861 37.1666 34.2502V16.7502C37.1666 15.1393 35.8607 13.8335 34.2499 13.8335H16.7499ZM24.0416 19.6675C24.0416 18.8621 24.6945 18.2092 25.4999 18.2092C26.3053 18.2092 26.9583 18.8621 26.9583 19.6675V24.0425H31.3333C32.1387 24.0425 32.7916 24.6955 32.7916 25.5009C32.7916 26.3063 32.1387 26.9592 31.3333 26.9592H26.9583V31.3342C26.9583 32.1396 26.3053 32.7925 25.4999 32.7925C24.6945 32.7925 24.0416 32.1396 24.0416 31.3342V26.9592L19.6666 26.9592C18.8612 26.9592 18.2083 26.3063 18.2083 25.5009C18.2083 24.6955 18.8612 24.0425 19.6666 24.0425H24.0416V19.6675Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4167 10.9167C26.8058 10.9167 25.5 12.2226 25.5 13.8334V18.2091C26.3054 18.2091 26.9583 18.862 26.9583 19.6675L26.9583 24.0425H31.3333C32.1385 24.0425 32.7913 24.695 32.7917 25.5001H37.1667C38.7775 25.5001 40.0833 24.1942 40.0833 22.5834V13.8334C40.0833 12.2226 38.7775 10.9167 37.1667 10.9167H28.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 25.5001C18.2083 25.4998 18.2083 25.5003 18.2083 25.5001C18.2083 26.3055 18.8612 26.9591 19.6666 26.9591L24.0416 26.9591V31.3341C24.0416 32.1395 24.6945 32.7924 25.5 32.7924V37.1667C25.5 38.7776 24.1941 40.0834 22.5833 40.0834H13.8333C12.2225 40.0834 10.9166 38.7776 10.9166 37.1667V28.4167C10.9166 26.8059 12.2225 25.5001 13.8333 25.5001H18.2083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomStarterIconColour);
export default __webpack_public_path__ + "static/media/CustomStarterIconColour.f072ae07dc31c6255cd9d8f52d574489.svg";
export { ForwardRef as ReactComponent };